/*
 * remove creates the on click listener for js-remove.
 *
 * The on click listener is used in situations where an element needs to be removed.
 *
 * Requires element with class 'js-remove'.
 * - data-remove               (Element to remove, eg #element or .element)
 */

const remove = () => {
  if ($('.js-remove').length === 0) {
    return;
  }

  $('.js-remove').on('click', function handleClick() {
    const target = $(this).data('remove');
    const $el = $(target);
    if ($el.length === 1) {
      $el.remove();
    }
  });
};

export default remove;
